module.exports = __webpack_public_path__ + "img/review-3.1510abeb.png";